import { Heading } from '@lmig/lmds-react-typography';
import SitecoreLink from 'Foundation/GlassMapper/SitecoreLink';
import { useUserData } from 'Foundation/User/UserContext';
import { FunctionComponent, useMemo } from 'react';
import { populateTokens } from 'Utilities/URLHelper';

const NavSection: FunctionComponent<IReactNavSection> = (props: IReactNavSection) => {
  const { userData } = useUserData();

  const navLinks = useMemo(() => {
    if (!props?.Links || !userData) {
      return [];
    }
    return populateTokens(props.Links, userData);
  }, [props, userData?.selectedStatCodeData?.SubStat, userData?.state]);

  const filteredNavLinks = useMemo(() => {
    if (!userData) {
      return navLinks;
    }
    return navLinks.filter((x) => x.IncludedStates.includes(userData.state));
  }, [navLinks, userData?.state]);

  return (
    <>
      <div className="navigation-section">
        {props.Title && (
          <Heading type="h4-light">
            {props.Link?.Url ? (
              <SitecoreLink
                Class={props.Link.Class}
                Goal={props.Link.Goal}
                key={props.Link.Text}
                Target={props.Link.Target}
                Text={props.Title}
                Url={props.Link.Url}
              />
            ) : (
              props.Title
            )}
          </Heading>
        )}
        <div className="menu-section-links">
          {filteredNavLinks &&
            filteredNavLinks.length > 0 &&
            filteredNavLinks.map((link: INavigationLink) => (
              <div className="menu-section-link" key={link.Link.Text}>
                <SitecoreLink
                  Class={link.Link.Class}
                  Goal={link.Link.Goal}
                  Target={link.Link.Target}
                  Text={link.Link.Text}
                  Url={link.Link.Url}
                  TargetId={link.Link.TargetId}
                  CaretPosition={'none'}
                />
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default NavSection;
